import { render, staticRenderFns } from "./MobileAppConfigurationPage.vue?vue&type=template&id=3c8e30ca&scoped=true&lang=pug"
import script from "./MobileAppConfigurationPage.vue?vue&type=script&lang=js"
export * from "./MobileAppConfigurationPage.vue?vue&type=script&lang=js"
import style0 from "./MobileAppConfigurationPage.vue?vue&type=style&index=0&id=3c8e30ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e30ca",
  null
  
)

export default component.exports